import "./brand-kit.css";

const brandSections = [
  {
    title: "Color Palette",
    description:
      "Define your brand colors to be able to use them from anywhere in the app.",
    icon: "🎨",
  },
  {
    title: "Cutouts",
    description: "Reuse previously made cutouts from anywhere in the app.",
    icon: "✂",
  },
  {
    title: "Backgrounds",
    description: "Reuse any background with all their smart features attached.",
    icon: "🖼",
  },
  {
    title: "Ai Backgrounds",
    description: "Reuse any background with all their smart features attached.",
    icon: "◉",
  },
];

const BrandKit = () => {
  return (
    <div className="brand-kit-page">
      <div className="brand-kit-header">
        <h1>Brand Kit</h1>
      </div>

      <div className="brand-kit-main-scroll">
        <div className="brand-kit-body">
          <section className="brand-kit-main">
          <p className="brand-kit-subtitle">
            A place for you to manage your collection of all the visual and style elements
            that define your brand looks and feels everywhere — It ensures your brand
            always appears consistent and recognizable.
          </p>

          <div className="brand-kit-block">
            <h2>Logo</h2>
            <div className="brand-kit-upload-box">
              <span className="upload-icon">☁</span>
              <span>
                Add your brand logos for easy access anywhere in the app. Drop
                a file or <a href="#">select an image</a>
              </span>
            </div>
          </div>

            {brandSections.map((section) => (
              <div className="brand-kit-block" key={section.title}>
                <div className="brand-kit-block-header">
                  <h2>{section.title}</h2>
                  <button type="button" className="brand-kit-add-btn">
                    + Add
                  </button>
                </div>
                <div className="brand-kit-helper">
                  <span className="helper-icon">{section.icon}</span>
                  <p>{section.description}</p>
                </div>
              </div>
            ))}
          </section>

          <aside className="brand-kit-info-panel">
            <h2 className="brand-kit-info-heading">Brand info</h2>

            <label>Brand Name</label>
            <input type="text" placeholder="Add your brand name" />

            <label>Tag line</label>
            <input type="text" placeholder="Add your brand tag line" />

            <label>Brand description</label>
            <textarea placeholder="Add your brand description" rows={4} />
            <p className="brand-kit-note">
              We’ll use it to personalize the AI imagery you create.
            </p>

            <label>Website</label>
            <input type="text" placeholder="Add website" />
            <p className="brand-kit-note">
              We’ll be able to import logos, colors and fonts for you.
            </p>

            <label>Instagram</label>
            <input type="text" placeholder="Add Instagram" />
            <p className="brand-kit-note">
              Automatically generate on brand social posts.
            </p>

            <label>Facebook</label>
            <input type="text" placeholder="Add Facebook" />
            <p className="brand-kit-note">
              Automatically generate on brand social posts.
            </p>

            <label>Twitter</label>
            <input type="text" placeholder="Add Twitter" />
            <p className="brand-kit-note">
              Automatically generate on brand social posts.
            </p>

            <button type="button" className="brand-kit-save-btn">
              save
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BrandKit;
